export const openStats = (Id1, Id2?) => {

    // remove unifies-feed prefixes
    if (Id2 == 'undefined') {
        if(String(Id1).indexOf(srvg.config.unifiedPrefixes.match)!= -1) {
            Id1 = parseInt(Id1.substring(srvg.config.unifiedPrefixes.match.length), 10);
        }
    } else {
        if(String(Id1).indexOf(srvg.config.unifiedPrefixes.competitor)!= -1) {
            Id1 = parseInt(Id1.substring(srvg.config.unifiedPrefixes.competitor.length), 10)
        }
        if(String(Id2).indexOf(srvg.config.unifiedPrefixes.competitor)!= -1) {
            Id2 = parseInt(Id2.substring(srvg.config.unifiedPrefixes.competitor.length), 10);
        }
    }

    srvg.customerIntegration.openStatisticCenter(Id1, Id2);

    return false;
}